<template>
  <v-container>
    <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
    <div style="padding: 10px; text-align: center;">
      <h3 class="printNone">{{ $t('page_license.renewal_trading', { year: valid_until || metadata.license_system_year }) }}</h3>
    </div>
    <v-layout justify-center align-start v-if="Object.keys(data).length === 0" class="printNone pa-2">
      <v-flex xl2 md4 sm6 xs12>
        <v-card class="br-10 pa-4 text-center">
            <div class="title pa-3">{{ $t('no_account_selected') }}</div>
            <v-layout row wrap pt-2 justify-center>
              <v-btn color="primary" class="white--text mx-3" rounded type="button" large @click="$router.push('/'); resetData()">{{ $t('go_to_homepage') }}</v-btn>
            </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout v-if="data && Object.keys(data).length !== 0" row wrap :column="$vuetify.breakpoint.xsOnly" class="pa-5">
      <v-layout id="printLayout" justify-center row wrap>
        <v-layout row style="text-align: center; margin-top: 5em;" class="printShow">
          <v-layout column style="margin-right: -2em;">
            <!-- <span><img src="img/mdkgu.png" alt="MDKGU Logo" height="65" width="62"></span> -->
            <span>MAJLIS DAERAH KENINGAU</span>
            <span>PETI SURAT 181, 89008 KENINGAU, SABAH MALAYSIA</span>
            <span>TEL: 087-341152, FAX: 087-339986'</span>
          </v-layout>
          <qrcode-vue :value="url" size="80" level="H" style="text-align: right; margin-top: -6em;"></qrcode-vue>
        </v-layout>
        <v-flex xs12 sm10 class="property_info">
          <h3 class="printShow" style="padding: 10px;">{{ $t('page_license.info2') }}</h3>
          <v-alert
            border="left"
            color="indigo"
            dark
            v-if="early_renewal"
          >
            {{ $t('page_license.early_renewal_hint', {
              early_renewal_open: early_renewal
                ? $t('page_license.open').toUpperCase()
                : $t('page_license.close').toUpperCase()
              })
            }}
          </v-alert>

          <v-select
            v-model="valid_until"
            :items="years.filter(row => early_renewal ? row : row === metadata.license_system_year)"
            :label="$t('page_license.renewal_until')"
          />
          <v-card outlined>
            <v-list bordered two-line class="display-flex" dense>
              <v-subheader class="printNone"><h3>{{ $t('page_license.info2') }}</h3></v-subheader>
              <v-divider class="printNone"/>
              <v-list-item class="width33">
                <v-list-item-action class="printNone">
                  <v-icon color="primary lighten-2" class="pl-2">fa-bookmark fa-lg</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title class="body-2">{{ data.no_lesen }}</v-list-item-title>
                  <v-list-item-subtitle class="body-2">{{ $t('page_license.license_no2') }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="width33">
                <v-list-item-action class="printNone">
                  <v-icon color="primary lighten-2" class="pl-2">fa-bookmark fa-lg</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title class="body-2">{{ data.nama_s !== '-' ? hideText(data.nama_s) : "-" }}</v-list-item-title>
                  <v-list-item-subtitle class="body-2">{{ $t('page_license.company_name') }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
          <br/>
          <v-card outlined>
            <v-subheader class="printNone"><h4>{{ $t('page_license.payment_needed') }}</h4></v-subheader>
            <v-divider class="printNone"/>
            <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      No.
                    </th>
                    <th class="text-left">
                      {{ $t('page_license.payment_type') }}
                    </th>
                    <th class="text-left">
                      {{ $t('page_license.account_no') }}
                    </th>
                    <th class="text-left">
                      {{ $t('page_license.amount_rm') }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in trading_payments"
                    :key="index"
                  >
                    <td>{{ index+1 }}</td>
                    <td>{{ $t(item.jenis_bayaran) }}</td>
                    <td>{{ item.ruj_akaun }}</td>
                    <td class="text-right" v-if="item._id && item._id.startsWith('ASVI-')">
                      {{ (valid_until === metadata.license_system_year ? item.bayaran / 100 : item.bayaran2 / 100) }}
                    </td>
                    <td class="text-right" v-else>
                      {{ (valid_until === metadata.license_system_year ? item.bayaran : item.bayaran2) | currency('') }}
                    </td>
                  </tr>
                  <tr>
                    <th></th>
                    <th></th>
                    <th class="text-left" style="font-size: 16px">
                      {{ $t('page_license.total') }}
                    </th>
                    <th class="text-right text-subtitle2" style="font-size: 16px">
                      {{ total() | currency('') }}
                    </th>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-flex>
        <v-btn :disabled="total() === 0" :block="$vuetify.breakpoint.xsOnly" color="indigo" class="white--text mx-2 mt-4" large rounded @click="payOnline(data)">{{ $t('page_license.pay_renew_online') }}</v-btn>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import vuex from 'vuex'
import QrcodeVue from 'qrcode.vue'
import configurations from '../../configurations'

export default {
  beforeMount () {
    this.resetData()
    this.fetchData({ id: atob(this.$route.params.id) })
  },
  components: {
    QrcodeVue
  },
  computed: {
    ...vuex.mapState({
      data: state => state.search.data,
      loading: state => state.search.loading,
      trading_payments: state => state.search.trading_payments,
      years: state => state.search.years,
      metadata: state => state.search.metadata,
      early_renewal: state => state.search.metadata.early_renewal,
      license_system_year: state => state.search.metadata.license_system_year,
      username: state => state.auth.username
    })
  },
  data () {
    return {
      valid_until: new Date().getFullYear(),
      url: configurations.host.eservices + '/#/' + window.location.hash
    }
  },
  methods: {
    ...vuex.mapActions({
      fetchData: 'search/fetchTradingRenewal'
    }),
    ...vuex.mapMutations({
      resetData: 'search/resetData'
    }),
    total: function () {
      let total = 0
      for (const element of this.trading_payments) {
        if (element._id && element._id.startsWith(`ASVI-`)) {
          total += (this.valid_until === new Date().getFullYear()
            ? Number(element.bayaran) / 100
            : Number(element.bayaran2) / 100)
        } else {
          total += (this.valid_until === new Date().getFullYear()
            ? Number(element.bayaran)
            : Number(element.bayaran2))
        }
      }
      return total
    },
    hideIC: function (text) {
      var t = text || ''
      var hiddenText = ''
      if (t.length !== 0) {
        for (var i = 0; i < t.length; i++) {
          if (i < t.length - 4) {
            hiddenText += '*'
          } else {
            hiddenText += t[i]
          }
        }
      }
      return hiddenText
    },
    hideText (text) {
      var t = text || ''
      var hiddenText = ''
      for (var i = 0; i < t.length; i++) {
        if (i > 4) {
          hiddenText += '*'
        } else {
          hiddenText += t[i]
        }
      }
      return hiddenText
    },
    payOnline (data) {
      if (!window.hasOwnProperty('cordova')) {
        window.location.href = `${configurations.host.epayment}/#/confirmation?_id=${
          btoa(data.lic_rujukan)
        }&council=${configurations.council}&payment_type=license_trading`
        return
      }
      let ref = cordova.InAppBrowser.open(`${configurations.host.epayment}/#/confirmation?_id=${
        btoa(data.lic_rujukan)
      }&council=${configurations.council}&payment_type=license_trading`, '_self', 'location=no,enableViewportScale=yes,zoom=no')
      let params = ''
      ref.addEventListener('loadstop', function (event) {
        if (event.url.substring(0, 41) === `${configurations.host.epayment}/#/receipt?`) {
          params = event.url.substring(41, event.url.length)
          ref.close()
          this.$router.push('/receipt?' + params)
        }
        if (event.url === `${configurations.host.epayment}/#/index.html#/` || event.url === `${configurations.host.epayment}/#/`) {
          ref.close()
          this.$router.push('/')
        }
      }.bind(this))
    },
    print: async function (data, type) {
      const id = atob(this.$route.params.id)
      const record = Object.assign({}, data, {
        dependencies: this.trading_payments,
        url: `${configurations.host.eservices}/#/trading/renewal/` + btoa(data.no_lesen),
        barcode: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE8AAAAPCAYAAAClbJLqAAAAn0lEQVRYR+1XQQ6AMAiD/z96Zji0aYofsB7UkAnYAC0ZESv2ba3IzHruC9/LcGx9Fm39bdvQ1/bD9scAcTEHFYNz5FzZp/qHzmXKd4qrYpd/g/cWjsE71ezKE+Oi29Vt65l3k4wihq/BrEgEzzdxMVG58oAaGTBkRMXyBs/gvdrPbWuRXNWgZq1FMm1I0+Zj8IYV0+vZ2b8tki2S/yuSL/vLwC5Di5poAAAAAElFTkSuQmCC'
      })
      const params = {
        record,
        year: this.valid_until
      }
      const fileName = 'BORANGAKUANLESENPERNIAGAAN_' + id + '.pdf'
      let printWorker = new Worker('print/license/renewal_form.js')
      printWorker.onmessage = function (response) {
        if (!window.hasOwnProperty('cordova')) {
          const anchor = document.createElement('a')
          anchor.href = URL.createObjectURL(response.data)
          anchor.download = fileName
          document.body.appendChild(anchor)
          anchor.click()
          anchor.remove()
          return
        }
        const storageLocation = cordova.file.externalApplicationStorageDirectory
        var errorCallback = function (e) {
          console.error(e)
        }
        window.resolveLocalFileSystemURL(storageLocation,
          function (directory) {
            directory.getFile(fileName, {
              create: true,
              exclusive: false
            },
            function (fileEntry) {
              fileEntry.createWriter(function (writer) {
                writer.onwriteend = function () {
                  cordova.plugins.fileOpener2.open(
                    storageLocation + fileName,
                    'application/pdf',
                    {
                      error: function (e) {
                        console.error('Error status: ' + e.status + ' - Error message: ' + e.message)
                      },
                      success: function () {
                        console.info('file opened successfully')
                      }
                    }
                  )
                }
                writer.seek(0)
                writer.write(response.data)
              }, errorCallback)
            }, errorCallback)
          }, errorCallback)
      }
      printWorker.postMessage(params)
    }
  }
}
</script>

<style>
.br-10 {
  border-radius: 10px;
}

#councilInfo,
.printShow {
  display: none;
}

@media print {
  .v-app-bar {
    display: none;
  }
  #councilInfo,
  #councilInfo span {
    display: block;
    text-align: center;
  }
  #printLayout {
    margin-top: -110px;
  }
  .property_info {
    max-width: 400px;
  }
  .display-flex {
    display: flex;
  }
  .printShow {
    display: block;
  }
  .printNone {
    display: none;
  }
  .pageBreak {
    page-break-after: always;
  }
  .width25 {
    width: 25% !important;
  }
  .width33 {
    width: 33% !important;
  }
  .width50 {
    width: 50% !important;
  }
  .marginBottom40 {
    margin-bottom: -40px;
  }
}
</style>
